module.exports = __webpack_public_path__ + "static/logo-b71e9718564199131fb088ee508cf20b.png";